export const GET_ALERT         = 'GET_ALERT';